import Vue from "vue";
import Router from "vue-router";
// import AddBusinessDoc from "../views/AddBusinessDoc.vue";
// import KycVerify from "../views/KycVerify.vue";
// import Home from "../views/Home.vue";
import Wall from "../views/Wall.vue";
import SearchAllBusinessList from "../views/SearchAllBusinessList.vue";
import Notification from "../views/Notification.vue";
import AddNewBusiness from "../views/AddNewBusiness.vue";
import CheckInBusiness from "../views/CheckInBusiness.vue";
import SuggestInEditBusiness from "../views/SuggestInEditBusiness";
import BusinessDetail from "../views/BusinessDetail.vue";
import Profile from "../views/Profile.vue";
import SplashScreen from "../views/SplashScreen.vue";
import Location from "../views/Location.vue";
Vue.use(Router);

export default new Router({
    // mode: "history",
    base: process.env.BASE_URL,
    routes: [{
            path: "/",
            name: "SplashScreen",
            component: SplashScreen
        },

        {
            path: "/location",
            name: "Location",
            component: Location
        },
        {
            path: "/wall",
            name: "Wall",
            component: Wall
        },
        // {
        //     path: "/",
        //     name: "Wall",
        //     component: Wall
        // },

        {
            path: "/searchall-businesslist",
            name: "SearchAllBusinessList",
            component: SearchAllBusinessList
        },


        {
            path: "/add-new-business",
            name: "AddNewBusiness",
            component: AddNewBusiness
        },

        {
            path: "/check-in-business",
            name: "CheckInBusiness",
            component: CheckInBusiness
        },

        {
            path: "/suggest-in-edit-Business",
            name: "SuggestInEditBusiness",
            component: SuggestInEditBusiness
        },

        {
            path: "/notification",
            name: "Notification",
            component: Notification
        },
        {
            path: "/business-detail/:id",
            name: "BusinessDetail",
            component: BusinessDetail
        },

        {
            path: "/profile",
            name: "Profile",
            component: Profile
        }
    ]
});

Location.vue